/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { apiappointorder } from '@/api';
import { mapState, mapMutations } from 'vuex';
import Confirm from "vux/src/components/confirm/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import XDialog from "vux/src/components/x-dialog/index.vue"; // this line is trasformed by vux-loader
import XTextarea from "vux/src/components/x-textarea/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import CheckIcon from "vux/src/components/check-icon/index.vue"; // this line is trasformed by vux-loader
import BottomOptions from '@/components/BottomOptions';
export default {
  components: {
    // MakeTag: () => import('./MakeTag'),
    OrderMessage: function OrderMessage() {
      return import('./OrderMessage');
    },
    GeneralEvaluate: function GeneralEvaluate() {
      return import('./GeneralEvaluate');
    },
    TpDialog: function TpDialog() {
      return import('@/components/NewVuxComponents/TpDialog');
    },
    Confirm: Confirm,
    BottomOptions: BottomOptions,
    XDialog: XDialog,
    XTextarea: XTextarea,
    Group: Group,
    CheckIcon: CheckIcon
  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    oid: String,
    orderInfo: Object,
    template: Object // 模板信息
  },
  data: function data() {
    return {
      messageShow: false,
      tagShow: false,
      evaluateShow: false,
      formData: {},
      // 编辑款项
      service: {},
      title: '',
      showCancelOrderModal: false,
      // 拒绝工单
      remark: '' // 拒绝原因
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user', 'config'])), {}, {
    isRefuse: function isRefuse() {
      return this.orderInfo.is_refuse_acceptance === 1;
    },
    isProduction: function isProduction() {
      return process.env.NODE_ENV === 'production';
    },
    isGeneralEvaluate: function isGeneralEvaluate() {
      return [5].indexOf(this.orderInfo.state) !== -1 && this.orderInfo.evaluate_state === 0;
    },
    istagShow: function istagShow() {
      return [1, 3].indexOf(this.user.sysrole) !== -1;
    },
    isCancelOrder: function isCancelOrder() {
      return [0, 1, 2].indexOf(this.orderInfo.state) !== -1;
    },
    bottomLeft: function bottomLeft() {
      var list = [];
      list.push({
        name: 'message',
        text: i18n.tc("584"),
        icon: 'message32_30@3x_1'
      });

      // if (this.istagShow) {
      //   list.push({
      //     name: 'tag',
      //     text: '打标',
      //     icon: 'edittag28_32@3x'
      //   })
      // }

      return list;
    },
    bottomRight: function bottomRight() {
      var list = [];
      if (this.isRefuse) {
        list.push({
          name: 'reAppoint',
          text: i18n.tc("666")
        });
      } else {
        // 工单状态：已完成 未评价
        if (this.isGeneralEvaluate) {
          list.push({
            name: 'serviceEval',
            text: i18n.tc("657")
          });
        }

        // 工单状态：未接单
        if (this.isCancelOrder) {
          list.push({
            name: 'cancelOrder',
            text: i18n.tc("658")
          });
        }
      }
      // 最多只有两个按钮 主要次要颜色固定
      if (list.length > 0) {
        list[list.length - 1].color = ['rgb(60, 203, 166)', 'rgb(94, 210, 152)'];
      }
      if (list.length > 1) {
        list[list.length - 2].color = ['rgb(166, 224, 199)', 'rgb(148, 219, 205)'];
      }
      if (list.length > 2) {
        list[list.length - 3].color = ['rgb(166, 224, 199)', 'rgb(148, 219, 205)'];
      }
      if (list.length > 3) {
        list[list.length - 4].color = ['rgb(60, 203, 166)', 'rgb(148, 219, 205)'];
      }
      return list;
    }
  }),
  watch: {},
  methods: _objectSpread(_objectSpread({}, mapMutations('globalStore', ['_pageReload'])), {}, {
    onClick: function onClick(name) {
      var _this = this;
      var actions = {
        cancelOrder: function cancelOrder() {
          _this.showCancelOrderModal = true;
        },
        // 取消工单
        message: function message() {
          _this.messageShow = true;
        },
        // 留言
        tag: function tag() {
          _this.tagShow = true;
        },
        // 标签
        serviceEval: function serviceEval() {
          _this.evaluateShow = true;
        },
        // 评价
        reAppoint: function reAppoint() {
          _this.$router.push({
            name: 'Appointment',
            query: {
              id: _this.orderInfo.server_id,
              oid: _this.oid
            }
          });
        }
      };
      actions[name]();
    },
    showUpdate: function showUpdate(title, content) {
      this.$vux.confirm.show({
        title: title,
        content: content,
        cancelText: i18n.tc("659"),
        confirmText: i18n.tc("660"),
        hideOnBlur: true,
        onShow: function onShow() {},
        onHide: function onHide() {},
        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {}
      });
    },
    // 取消工单
    cancelOrderSubmit: function cancelOrderSubmit() {
      var _this2 = this;
      if (this.remark && this.remark !== '') {
        if (this.remark > 500) {
          this.$vux.toast.text(i18n.tc("661"));
          return;
        }
        apiappointorder({
          oid: this.oid,
          cancel_remark: this.remark
        }, 'put').then(function (res) {
          if (res.success) {
            _this2.$vux.toast.text(i18n.tc("668"));
            _this2.showCancelOrderModal = false;
            _this2.remark = '';
            _this2.$emit('on-success');
          } else {
            _this2.$vux.toast.text(res.message);
          }
        });
      } else {
        this.$vux.toast.text(i18n.tc("663"));
      }
    }
  }),
  created: function created() {
    // this.loadEditAmount()
  }
};